import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


type Props = {
  name?: string;
  avatar?: string;
  rating?: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerInfoTile',
  props: {
    name: null,
    avatar: null,
    rating: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "userInfo" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_item, {
        "prepend-avatar": 
        __props.avatar === undefined ? undefined : 'data:image/png;base64,' + __props.avatar
      ,
        title: __props.name ?? '',
        subtitle: __props.rating === undefined ? '' : 'rating: ' + __props.rating
      }, null, 8, ["prepend-avatar", "title", "subtitle"])
    ]),
    _: 1
  }))
}
}

})